export interface UpdateDefaultParameterOrderListDefaultValueRequest {
  id: string
  revision: number
}

export function UpdateDefaultParameterOrderListDefaultValueRequestToJSON(
  value: UpdateDefaultParameterOrderListDefaultValueRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
